var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.warnings.length)?_c('v-alert',{staticClass:"mail-variable-alert text-caption mb-2",attrs:{"type":"warning","text":"","dense":""}},_vm._l((_vm.warnings),function(warning){return _c('div',{key:warning.variable.name},[_vm._v(" "+_vm._s(warning.text)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }